if (!customElements.get('countdown-bar')) {
  customElements.define(
    'countdown-bar',
    class CountdownBar extends HTMLElement {
      connectedCallback() {
        this.mode = this.dataset.mode;
        this.daysEl = this.querySelector('[data-unit="days"]');
        this.hoursEl = this.querySelector('[data-unit="hours"]');
        this.minutesEl = this.querySelector('[data-unit="minutes"]');
        this.secondsEl = this.querySelector('[data-unit="seconds"]');

        this.tick();
        this.interval = setInterval(this.tick.bind(this), 1000);
      }

      disconnectedCallback() {
        if (this.interval) clearInterval(this.interval);
      }

      getRemainingMs() {
        const now = Date.now();

        if (this.mode === 'recurring') {
          const durationMs = parseFloat(this.dataset.durationHours) * 60 * 60 * 1000;
          if (!durationMs || durationMs <= 0) return 0;
          const cycleEnd = Math.ceil(now / durationMs) * durationMs;
          return cycleEnd - now;
        }

        const end = new Date(this.dataset.end).getTime();
        if (Number.isNaN(end)) return 0;
        return end - now;
      }

      tick() {
        const remainingMs = this.getRemainingMs();

        if (remainingMs <= 0) {
          if (this.mode === 'recurring') {
            this.render(0, 0, 0, 0);
          } else {
            if (this.interval) clearInterval(this.interval);
            this.setAttribute('hidden', '');
          }
          return;
        }

        const totalSeconds = Math.floor(remainingMs / 1000);
        const days = Math.floor(totalSeconds / 86400);
        const hours = Math.floor((totalSeconds % 86400) / 3600);
        const minutes = Math.floor((totalSeconds % 3600) / 60);
        const seconds = totalSeconds % 60;

        this.render(days, hours, minutes, seconds);
      }

      render(days, hours, minutes, seconds) {
        const pad = (value) => String(value).padStart(2, '0');
        if (this.daysEl) this.daysEl.textContent = pad(days);
        if (this.hoursEl) this.hoursEl.textContent = pad(hours);
        if (this.minutesEl) this.minutesEl.textContent = pad(minutes);
        if (this.secondsEl) this.secondsEl.textContent = pad(seconds);
      }
    }
  );
}
